import { Spin } from 'antd';
import { FunnelChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  sort?: 'ascending' | 'descending';
}
type Data = Array<{ name: string; value: number }>;

function FunnelWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id, 'funnel', instance.config as Record<string, unknown>, instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return <FunnelChart data={data ?? []} />;
}

export const funnelWidgetDef: WidgetDefinition<Config> = {
  type: 'funnel',
  name: 'Funnel Chart',
  description: 'Progressive stages',
  icon: 'FallOutlined',
  category: 'chart',
  defaultTitle: 'Funnel Chart',
  defaultConfig: {},
  minW: 3, minH: 5, defaultW: 4, defaultH: 7,
  component: FunnelWidget,
  settingsSchema: { fields: [] },
};
